import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-8 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-163">
      <FadeIn data-id="element-164">
        <div className="bg-[#0a0a0a] border border-[#c9a961]/30 rounded-2xl md:rounded-[2.5rem] p-5 md:p-16 text-center relative overflow-hidden shadow-[0_20px_50px_rgba(10,10,10,0.15)]" data-id="element-165">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#c9a961_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-166"></div>

          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-transparent via-[#c9a961] to-transparent" data-id="element-167"></div>

          <div className="relative z-10" data-id="element-168">
            <div className="inline-flex items-center justify-center w-20 h-20 md:w-28 md:h-28 rounded-full bg-[#c9a961]/10 mb-4 md:mb-8 border-2 border-[#c9a961]/20 relative" data-id="element-169">
              <div className="absolute inset-0 bg-[#c9a961]/20 blur-2xl rounded-full animate-pulse" data-id="element-170"></div>
              <ShieldCheck className="w-10 h-10 md:w-14 md:h-14 text-[#c9a961] relative z-10" data-id="element-171" />
              <div className="absolute -bottom-2 -right-2 bg-[#c9a961] text-black rounded-full p-1.5 md:p-2 shadow-lg" data-id="element-172">
                <Award className="w-4 h-4 md:w-5 md:h-5" data-id="element-173" />
              </div>
            </div>

            <h2 className="text-2xl md:text-5xl font-black mb-4 md:mb-8 text-white tracking-tight" data-id="element-174">
              GARANTÍA 7 DÍAS <br className="md:hidden" data-id="element-175" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#c9a961] to-[#d4af37]" data-id="element-176">
                — SIN PREGUNTAS
              </span>
            </h2>

            <div className="space-y-3 md:space-y-6 text-base md:text-2xl text-[#e8dfd0] font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-177">
              <p data-id="element-178">
                Abrís los tomos. Los usás 7 días. Si no es lo que esperabas:
              </p>
              <motion.div whileHover={{
              scale: 1.05
            }} className="bg-[#c9a961]/10 border border-[#c9a961]/30 rounded-2xl p-4 md:p-6 mt-4 md:mt-8 inline-block" data-id="element-179">
                <p className="text-[#c9a961] font-black text-lg md:text-3xl" data-id="element-180">
                  → Devolución del 100%. <br className="md:hidden" data-id="element-181" />
                  Sin formularios. Sin drama.
                </p>
              </motion.div>
              <p className="text-xs md:text-sm text-[#6b5d4f] mt-5 md:mt-10 pt-4 md:pt-8 border-t border-[#c9a961]/20 uppercase tracking-widest font-bold" data-id="element-182">
                Tasa de devolución: &lt; 1%.
              </p>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}